import { Component, OnInit } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFireAuth } from 'angularfire2/auth';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';


@Component({
  selector: 'app-forum-detail',
  templateUrl: './forum-detail.component.html',
  styleUrls: ['./forum-detail.component.scss'],
  providers: [AngularFireDatabase, AngularFireAuth],
})
export class ForumDetailComponent implements OnInit {
  forum : any = {};
  forumId : any;
  user : any;

  constructor(private db: AngularFireDatabase, private route : ActivatedRoute, private afAuth : AngularFireAuth) {

  }

  ngOnInit() {
    this.afAuth.auth.onAuthStateChanged(user => {
      this.user = user;
    })

    this.route.params.subscribe(params => {
     this.forumId = params['id'];

     this.db.object('discussions/'+this.forumId)
        .snapshotChanges()
        .subscribe(topic => {
          this.forum = topic.payload.val();
        });
    });
  }

}



// WEBPACK FOOTER //
// /mnt/d/Projects/angular/chisparural-foro/src/app/forum/forum-detail/forum-detail.component.ts